import { Inject, Injectable } from '@angular/core';
import { HttpInterceptorService } from '../../../core/services/http-interceptor.service';
import { Store, select } from '@ngrx/store';
import { IgenomicsState } from '../../../core/interfaces/genomics-state.interface';
import { DynamicModalLoaderService } from '@ispm/layout/services/dynamic-modal-loader.service';
import { ModalTypes } from '@ispm/layout/components/modals/contants/modal-types.enum';
import { flatMap, map } from 'rxjs/operators';
import { modalResponse } from '@ispm/layout/constants/modal-responses.enum';
import { Observable } from 'rxjs';
import { ModalLoaderPayload } from '@ispm/layout/classes/modal-loader-payload.abstract';

@Injectable()
export class DisclaimerService {
	public static baseUrl = '/practitioner';
	private fetched: boolean = false;

	constructor(
		private _http: HttpInterceptorService,
		private popupLoader: DynamicModalLoaderService,
		private store: Store<IgenomicsState>
	) {	}

	openDisclaimerModel(options: OpenDisclaimerModalOptions) {
		return this.popupLoader.popupModal(options.component,
			options.payload,
			ModalTypes.ALERT
		).pipe(
			map((res) => res.payload),
			flatMap((res: modalResponse) => {
				if (res == modalResponse.approve) {
					this.markDisclaimer(options.practitionerId);
				}
				return Observable.empty();
			})
		);
	}

	getPractitioner(practitionerId) {
		return this._http.get<any>(DisclaimerService.baseUrl, { id: practitionerId}, true)
			.map(response => response.body);
	}

	private markDisclaimer(practitionerId) {
		this.fetched = true;
		this._http.post<any>(DisclaimerService.baseUrl + '/markDisclaimer', { id: practitionerId}, true)
			.map(response => response.body)
			.subscribe(config => {
				this.fetched = false;
			});
	}

}

export class OpenDisclaimerModalOptions {
	practitionerId: string;
	component: any;
	payload: ModalLoaderPayload;

	constructor(options: { [key in keyof OpenDisclaimerModalOptions]: any }) {
		this.component = options.component;
		this.payload = options.payload;
		this.practitionerId = options.practitionerId;
	}
}
